import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import PopupAlert, { usePopup } from "./PopupAlert";
import "./BookingPage.css";

const BookingPage = () => {
  const navigate = useNavigate();
  const { popup, showPopup, closePopup } = usePopup();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    location: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("/api/bookings", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        showPopup(`✨ Success! Trip booked for ${formData.name}.`, "success");
        setFormData({ name: "", email: "", number: "", location: "" });
        // Navigate home after user closes popup
      } else {
        showPopup(`Error: ${data.message || "Failed to book"}`, "error");
      }
    } catch (error) {
      console.error("Booking error:", error);
      showPopup(
        "Could not connect to the server. Please check your internet.",
        "error",
      );
    }
  };

  const handlePopupClose = () => {
    closePopup();
    // If it was a success popup, go home
    if (popup?.type === "success") navigate("/");
  };

  return (
    <div className="booking-container">
      {/* Custom Popup */}
      <PopupAlert popup={popup} onClose={handlePopupClose} />

      <motion.div
        key="booking-form-unique"
        initial={{ opacity: 0, scale: 0.9, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="booking-card"
      >
        <h2>Secure Your Spot</h2>
        <p>Journey to the edge of the world with us.</p>

        <form onSubmit={handleSubmit} className="booking-form">
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            required
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            required
            onChange={handleChange}
          />
          <input
            type="tel"
            name="number"
            placeholder="Phone Number"
            value={formData.number}
            required
            onChange={handleChange}
          />
          <input
            type="text"
            name="location"
            placeholder="Where do you want to go?"
            value={formData.location}
            required
            onChange={handleChange}
          />

          <button type="submit" className="btn-submit">
            Confirm Booking
          </button>
          <button
            type="button"
            className="btn-cancel"
            onClick={() => navigate("/")}
          >
            Go Back
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default BookingPage;
